import { Div, TableHeader } from '@vgrubs/components';

export const OrdersTableHeader = () => {
  return (
    <Div $desktop>
      <TableHeader
        padding="0 20px"
        gap="12px"
        columns={[
          { label: 'Order ID', width: '5%' },
          { label: 'Number', width: '5%' },
          { label: 'Date & Time', width: '11%' },
          { label: 'Store', width: '18%' },
          { label: 'Customer', width: '10%' },
          { label: 'Type', width: '6%' },
          { label: 'Provider', width: '8%' },
          { label: 'vDrive', width: '9%' },
          { label: 'Status', width: '10%' },
          // { label: 'Paid', width: '5%' },
          { label: 'Recovery', width: '12%' },
          { label: 'Subtotal', width: '6%' },
        ]}
      />
    </Div>
  );
};
